export default __webpack_public_path__ + "static/media/piccolo_R1.138cdf5e.png";